import { render } from "./home_view.vue?vue&type=template&id=5a671eb2"
import script from "./home_view.vue?vue&type=script&lang=js"
export * from "./home_view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__